import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {Season} from "../../models/season";

@Injectable({
    providedIn: 'root'
})
export class SeasonService {

    constructor(private http: HttpClient) {
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    async getSeasons(companyId: string, params?: any) {
        let response: any;

        try {
            response = await this.http.get(environment.apiUrl + `/seasons`, {
                params: {companyId, ...params},
                headers: this.getRequestHeaders(),
            }).toPromise();

        } catch (e) {
            console.error('error getSeasons: ', e);
        } finally {
            return response;
        }
    }

    getSeasonById(seasonId: string) {
        return this.http.get(environment.apiUrl + `/seasons/${seasonId}`, {headers: this.getRequestHeaders()});
    }

    async addSeason(newSeason: Season) {
        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + '/seasons', newSeason, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error addSeason: ', e)
        } finally {
            return response;
        }
    }

    async updateSeason(updatedSeason: Season) {
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/seasons/${updatedSeason.id}`, updatedSeason, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error updateSeason: ', e)
        } finally {
            return response;
        }
    }

    async setSeasonStatus(seasonId: string) {

        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + `/seasons/${seasonId}/current`, {}, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error setSeasonStatus: ', e);
        } finally {
            return response;
        }

    }

}
